import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const AppointmentPatientBarChart = ({ data }) => {
    return (
        <div style={{ width: '100%', height: 300 }}>
            <ResponsiveContainer>
                <BarChart
                    data={data}
                    margin={{ top: 10, right: 30, left: 20, bottom: 10 }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="month" />
                    <YAxis allowDecimals={false} />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="rdv" fill="#3B82F6" name="Rendez-vous" />
                    <Bar dataKey="patient" fill="#10B981" name="Patients" />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default AppointmentPatientBarChart;
